
export { LucideIcon } from "/codebuild/output/src2340768698/src/packages/shared-components/src/components/LucideIcon.tsx"